var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckDecagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 56,
    viewBox: "0 0 60 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3337 27.9998L52.827 20.5864L53.7337 10.7731L44.107 8.58644L39.067 0.106445L30.0003 3.99978L20.9337 0.106445L15.8937 8.58644L6.26699 10.7464L7.17366 20.5598L0.666992 27.9998L7.17366 35.4131L6.26699 45.2531L15.8937 47.4398L20.9337 55.9198L30.0003 51.9998L39.067 55.8931L44.107 47.4131L53.7337 45.2264L52.827 35.4131L59.3337 27.9998ZM24.667 41.3331L14.0003 30.6664L17.7603 26.9064L24.667 33.7864L42.2403 16.2131L46.0003 19.9998L24.667 41.3331Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDecagram);
export default __webpack_public_path__ + "static/media/check-decagram.7d8256f222838d7e247c6c9ad52deb8b.svg";
export { ForwardRef as ReactComponent };